import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../../../styles/constants.style";

export const ViewGoalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.cirrus_white};
  gap: 32px;
  padding: 24px 16px;
  ${responsive.MOBILE`
      gap: 0;
      background-color: ${COLORS.cirrus_white};
    `}
  .content {
    width: 100%;

    ${responsive.MOBILE`
        padding: 16px 16px;
      `}
  }
`;
